import React, { useCallback, ComponentProps } from 'react';

import { Box, Text } from '@adsk/alloy-react-box';
import Button, { LinkButton } from '@adsk/alloy-react-button';
import { DateRangePicker, DatePicker } from '@adsk/alloy-react-date-picker';
import { useLocale } from '@adsk/alloy-react-locale';

type onChangeType = ComponentProps<typeof DateRangePicker>['onChange'];

function DateRangeFooter({
  today,
  reset,
}: {
  today?: () => void;
  reset?: () => void;
}) {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <DatePicker.Footer>
      <Button onClick={today} size={Button.SIZES.SMALL}>
        {T.translate('FILTERS.TODAY')}
      </Button>
      <LinkButton onClick={reset}>
        {T.translate('FILTERS.CLEAR_DATES')}
      </LinkButton>
    </DatePicker.Footer>
  );
}

function DateRangeFilter({
  dateRange = [],
  onChange,
}: {
  dateRange?: Date[];
  onChange: (key: string, value: (Date | null | undefined)[]) => void;
}) {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  const onChangeDate: onChangeType = useCallback(
    ({
      startDate,
      endDate,
    }: {
      startDate?: Date | null;
      endDate?: Date | null;
    }) => {
      onChange('dateRange', [startDate, endDate]);
    },
    [onChange],
  );

  return (
    <Box
      display="grid"
      gridAutoFlow="row"
      padding="24px 0 0"
      justifyContent="flex-start"
      style={{ rowGap: '8px' }}
    >
      <Text typography="labelSmall" color="charcoal700">
        {T.translate('FILTERS.DATE_RANGE')}
      </Text>
      <DateRangePicker
        startDate={dateRange?.[0] || null}
        endDate={dateRange?.[1] || null}
        renderFooter={(props: { today?: () => void; reset?: () => void }) => (
          <DateRangeFooter today={props.today} reset={props.reset} />
        )}
        onChange={onChangeDate}
      />
    </Box>
  );
}

export default DateRangeFilter;
